import { createSlice, createAsyncThunk, SerializedError } from '@reduxjs/toolkit'
import { createActionType } from './utils'
import { siteClient } from '../clients/SiteClient'
import { initialSitesState } from './initialStates'
import { SitesState } from './types'
import { SiteGates, SiteDirectory, Gate, Site } from '../models/client/site'

const REDUCER_NAME = 'sites'

const createSiteActionType = (name: string): string => createActionType(name, REDUCER_NAME)

// TODO: figure out if we need to refetch this info
export const getAllSitesAction = createAsyncThunk(
    createSiteActionType('getAll'),
    async ({ companyId, token }: { companyId: string; token: string }): Promise<SiteDirectory> => {
        const siteArr = await siteClient.getCompanySites({ companyId, token })

        const directory: SiteDirectory = {}
        siteArr.forEach((site) => {
            directory[site.id] = site
        })

        return directory
    }
)

const slice = createSlice({
    name: REDUCER_NAME,
    initialState: initialSitesState,
    reducers: {
        clearSitesAction(draft) {
            draft.directory = null
            draft.gates = null
            draft.loading = false
            draft.error = null
        },
    },
    extraReducers(builder) {
        builder.addCase(getAllSitesAction.pending, (draft) => {
            draft.directory = null
            draft.gates = null
            draft.loading = true
            draft.error = null
        })
        builder.addCase(getAllSitesAction.rejected, (draft, { error }) => {
            draft.error = error
            draft.loading = false
            draft.directory = null
            draft.gates = null
        })
        builder.addCase(getAllSitesAction.fulfilled, (draft, { payload }) => {
            draft.directory = payload
            draft.loading = false
            draft.error = null
        })
    },
})

export const { reducer } = slice

export const { clearSitesAction } = slice.actions

type State = {
    sites: SitesState
}

export const selectSiteDirectory = (state: State): SiteDirectory | null => state.sites.directory

export const selectSiteList = (state: State): Array<Site> | null =>
    state.sites.directory ? Object.values(state.sites.directory) : null

export const selectSiteIds = (state: State): Array<string> | null =>
    state.sites.directory ? Object.keys(state.sites.directory) : null

export const selectSiteLoading = (state: State): boolean => state.sites.loading

export const selectSiteError = (state: State): SerializedError | null => state.sites.error

export const selectAllGates = (state: State): SiteGates | null => state.sites.gates

export const selectSiteGateList = (state: State): Gate[] => {
    const gates: Gate[] = []
    Object.values(state.sites.gates || {}).forEach((gateDirectory) => {
        gates.push(...Object.values(gateDirectory))
    })
    return gates
}
